import React from "react";

const ConfirmModal = ({ modalState, onClose, onConfirm }) => {
  if (!modalState) return null;

  const {
    type,
    itemId,
    title = "تأیید عملیات",
    message = "آیا از انجام این عملیات اطمینان دارید؟",
    confirmText = "تأیید",
    cancelText = "انصراف",
  } = modalState;

  return (
    <>
      <div
        className="modal confirm-delete fade show"
        tabIndex="-1"
        role="dialog"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{title}</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <p>{message}</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
              >
                {cancelText}
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={() => {
                  onConfirm(type, itemId);
                  onClose();
                }}
              >
                {confirmText}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default ConfirmModal;
